export default "__VITE_ASSET__CkfYupDF__"